import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Arrow from "components/effects/rack/Arrow.js";
import {getPath} from './getPath.js';

const MarkovEdge = ({transformation, container, scrollContainer, trackSteps}) => { 
    let [pos, setPos] = useState(undefined);
    useEffect(() => {
        setTimeout(() => {
            let fromId = transformation.id;
            let toId = transformation.whenValue.get();
            let fromEl = document.getElementById("transformation-" + fromId);
            let toEl = document.getElementById("transformation-" + toId);
            if (fromEl && toEl) {
                let fromRect = fromEl.getBoundingClientRect();
                let toRect = toEl.getBoundingClientRect();
                let bounds = container.current.getBoundingClientRect();
                let scrollTop = scrollContainer.current.scrollTop;
                setPos({
                    x2: fromRect.left + 3, 
                    y2: fromRect.top - bounds.top,
                    x1: toRect.left + 4,
                    y1: toRect.top - bounds.top 
                });
            }
        }, 100);
    }, [setPos, transformation, trackSteps]);

    if (!pos) {
        return [];
    }

    let {x1, y1,x2,y2} = pos;

    return (
        <Arrow
          className="markov-edge" 
          tension={window.tension}
          pointerLength= {6}
          pointerWidth={4}
          points={getPath(x1, y1, x2, y2)}
          strokeWidth={2} />);
}

const mapStateToProps = (state, props) => {
  return {
      trackSteps: state.tracks.trackSteps[props.track.trackNumber],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarkovEdge);
